import { Autocomplete } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { TextFieldComponent } from '../../../Components/shared/ReusableSmallComponents';
import { API_URI_CVTheque, getCVThequeENV } from '../../../config';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useWindowSize from '../../../hooks/useWindowSize';

function CompetenceComponent({skill,skillsTech,setSkillsTech,index,disabled}) {

    CompetenceComponent.propTypes = {
        skillsTech:PropTypes.any,
        skill:PropTypes.any,
        index:PropTypes.any,
        setSkillsTech:PropTypes.func,
        disabled:PropTypes.any,
    };
    const { i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const [techSkillSet,setTechSkillSet]=useState([]);
    const { inputSize } = useWindowSize();

    const searchSkills = async (skill) => {
        console.log('SEARCHING');
        try {
            let response1, responseData1;
            if(getCVThequeENV() == 'remote'){
                response1 = await axiosPrivate.get(
                    '/proxy/getSkills/'+encodeURIComponent(skill),
                );
                responseData1 = response1.data;
            }
            else {
                response1 = await fetch(API_URI_CVTheque + 'getSkills/'+encodeURIComponent(skill), {
                    method: 'get',
                });
                responseData1 = await response1.json();
            }

            console.log('skills list', responseData1);
            setTechSkillSet(responseData1);
        } catch (error) {
            console.log(error);
        }
    };
    console.log('skill',skill);
    return (
        <>
            <Autocomplete
                id="free-solo-2-demo"
                size={inputSize}
                sx={{
                    '& > :not(style)': {borderRadius: '8px'},
                }}
                freeSolo
                disabled={disabled}
                options={Array.isArray(techSkillSet)? techSkillSet.map((option) => option?.title) : []}
                value={skill?.titre || ''}
                onInputChange={(event, newInputValue) => {
                    console.log({event, newInputValue});
                    let newArr = [...skillsTech]; // copying the old datas array
                    newArr[index].titre = newInputValue; // replace e.target.value with whatever you want to change it to
                    setSkillsTech(newArr);
                    console.log('skillsTech apres',skillsTech);
                    searchSkills(newInputValue);
                }}
                renderInput={(params) =>
                    <TextFieldComponent
                        {...params}
                        label=""
                        placeholder={i18n.t('Compétence technique')}
                    />}
            />
        </>
    );
}
export default CompetenceComponent;
{/*<Autocomplete
                                                id="free-solo-2-demo"
                                                name='titre'
                                                // name='titre'

                                                size={inputSize}
                                                freeSolo
                                                options={Array.isArray(techSkillSet) ? techSkillSet.map((option) => option?.title) : []}
                                                value={element?.titre || ''}
                                                onInputChange={(event, newInputValue) => {
                                                    // let newArr = [...techSkillSet]; // copying the old datas array
                                                    // newArr.titre = newInputValue; // replace e.target.value with whatever you want to change it to
                                                    // setSkillsTech(newArr);
                                                    searchSkills(newInputValue);
                                                    // console.log({ event, newInputValue });
                                                    // handleInputChangeCompetencesTechAutocomplete(newInputValue, i);
                                                    //const handleInputChangeCompetencesTechAutocomplete= (e, index) => {
                                                    const list = [...competencesTech];
                                                    // if (!CompareTwoString(newInputValue, list[i]['titre']))
                                                    //     setCheckUpdateValue(false);
                                                    list[i]['titre'] = newInputValue;
                                                    setCompetencesTech(list);
                                                    // }
                                                }}
                                                sx={{
                                                    '& > :not(style)': { borderRadius: '8px' },
                                                }}
                                                style={{ width: '100%', borderRadius: '8px' }}
                                                renderInput={(params) => {
                                                    // console.log('inputProps', params);
                                                    return (
                                                        <TextFieldComponent
                                                            name='skillsTech'
                                                            {...params}
                                                        />);
                                                }}
                                            />*/}